import { useContext, useState } from "react"

import { useTranslation } from "react-i18next"

import { ReusableWizard } from "@oysterhr/feature-components"
import { BankDetails } from "./components/BankDetails"
import { ReviewBankDetails } from "./components/ReviewBankDetails"
import { BankDetailsAdvisor } from "./components/BankDetailsAdvisor"
import { Elements } from "@stripe/react-stripe-js"
import { loadStripe } from "@stripe/stripe-js/pure"
import { Pearl, PearlProvider } from "@oysterhr/pearl"
import { UrlQueryParamContext } from "@oysterhr/quarantine"
import { AddAchFormValues } from "~/app/pages/payments/types"
import { BankDetailsContext } from "./contexts/BankDetailsContext"
import ConnectPaymentMethodLayout from "../../../layouts/ConnectPaymentMethodLayout"
import { WizardPearlType } from "../../constants"

enum Step {
  Verification = "1",
  Authorization = "2",
}

const AchFlowPage = () => {
  const stripePromise = loadStripe(window.gon.stripeOysterhrPublishableKey)
  const [bankDetails, setBankDetails] = useState<AddAchFormValues | null>(null)
  const { t } = useTranslation("company_interface/CompanyPaymentMethodsPage/AchBankDetailsFlow")
  const { params } = useContext(UrlQueryParamContext)
  const step = (params?.page ?? "1") as Step

  return (
    <PearlProvider>
      <ConnectPaymentMethodLayout title={t("title")}>
        <div className="text-left">
          <Elements stripe={stripePromise}>
            <BankDetailsContext.Provider
              value={{
                bankDetails,
                setBankDetails,
              }}
            >
              <ReusableWizard scrollTopAfterTransition={true}>
                <ReusableWizard.Step
                  title={t("steps.bankDetails")}
                  subtitle={`${t("nextStep")} ${t("steps.reviewBankDetails")}`}
                >
                  <BankDetails />
                </ReusableWizard.Step>
                <ReusableWizard.Step title={t("steps.reviewBankDetails")} pageNumber={2}>
                  <ReviewBankDetails />
                </ReusableWizard.Step>
              </ReusableWizard>
            </BankDetailsContext.Provider>
          </Elements>
        </div>
        <Pearl name="ach-bank-details">
          <Pearl.SideBox>
            <BankDetailsAdvisor wizard={WizardPearlType.Contractor} step={parseInt(step)} />
          </Pearl.SideBox>
        </Pearl>
      </ConnectPaymentMethodLayout>
    </PearlProvider>
  )
}

export default AchFlowPage
